exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top[data-v-aa20b28c]{display:flex;justify-content:space-between;align-items:center}.top .add_new[data-v-aa20b28c]{flex:1;margin-top:-10px}.top .header_text_field[data-v-aa20b28c]{flex:2;margin-right:30px}.top .header_select_gateways[data-v-aa20b28c]{flex:1}.header[data-v-aa20b28c]{display:flex;justify-content:space-between;margin:1rem;align-items:center}.header .text[data-v-aa20b28c]{margin-top:5px;flex:2}.header .selectors[data-v-aa20b28c]{flex:3;display:flex;justify-content:space-around}.selected_options[data-v-aa20b28c]{display:flex;justify-content:space-between;padding:0 1rem}", ""]);

// exports
